import $ from "jquery";

$("#filter .js-value").click(function () {
  jQuery(
    '<div class="loader-wrapper"><div class="loader"><div></div><div></div><div></div><div></div></div></div>'
  ).insertAfter(jQuery("#filter"));
  jQuery(".response").show();
  jQuery(".material-repeater").hide();
  ajax_material_filter_terms();
});

$(".js-toggle-button").click(function () {
  var parent = $(this).parent().prop("className");
  var parentClassName = "." + parent;
  console.log(parentClassName);
  var checkBoxes = $(parentClassName + " input[type=checkbox]");
  checkBoxes.prop("checked", !checkBoxes.prop("checked"));
  $(this).prop("checked", checkBoxes.is(":checked"));
  jQuery("body").addClass("loading");
  jQuery(
    '<div class="loader-wrapper"><div class="loader"><div></div><div></div><div></div><div></div></div></div>'
  ).insertAfter(jQuery("#filter"));
  jQuery(".response").show();
  jQuery(".material-repeater").hide();
  ajax_material_filter_terms();
});

function ajax_material_filter_terms() {
  // Declaring the arrays
  var category = [];
  var store = [];
  var grocery = [];
  var commerce = [];

  // Empty the output before new filter option
  $(".filter-output").empty();

  // Push values from checkboxes
  $(".category input[type=checkbox]:checked").each(function () {
    category.push($(this).val());
  });

  $(".store input[type=checkbox]:checked").each(function () {
    store.push($(this).val());
  });

  $(".grocery input[type=checkbox]:checked").each(function () {
    grocery.push($(this).val());
  });

  $(".commerce input[type=checkbox]:checked").each(function () {
    commerce.push($(this).val());
  });

  // Save values to strings
  var categoryString = JSON.stringify(category);
  var storeString = JSON.stringify(store);
  var groceryString = JSON.stringify(grocery);
  var commerceString = JSON.stringify(commerce);

  $.ajax({
    url: adminAjaxURL,
    type: "POST",
    data: {
      action: "call_post", // the php name function
      category: categoryString,
      store: storeString,
      grocery: groceryString,
      commerce: commerceString,
    },
    success: function (result) {
      /* Put result in this element */
      $(".filter-output").append(result);
      jQuery("body").removeClass("loading");
      jQuery(".loader-wrapper").remove();
    },
    error: function (err) {},
  });
}
